import { RampFormStore } from './RampFormStore';

export interface IAccountSignInFormValues {
    // either email address or mobile number, will translate this to emailAddress or mobileNumber in payload based on it's value
    accountIdentifier: string;
    password: string;
}

export class AccountSignInFormStore extends RampFormStore<IAccountSignInFormValues> {
    constructor() {
        super({
            accountIdentifier: '',
            password: ''
        });
    }
}
